(function (root) {
  'use strict';
  const bases = {
    '8395112185971': ['ford', 2011, 2016, 6.7],
    '8397315309683': ['ford', 2017, 2019, 6.7],
    '8397315702899': ['ford', 2020, 2022, 6.7],
    '8397360136307': ['ford', 2023, 2026, 6.7],
    '8401699504243': ['gm', 2011, 2016, 6.6],
    '8401729683571': ['gm', 2017, 2019, 6.6],
    '8401749737587': ['gm', 2019, 2023, 6.6],
    '8401902469235': ['gm', 2024, 2026, 6.6],
    '8401920360563': ['ram', 2013, 2018, 6.7],
    '8401920458867': ['ram', 2019, 2021, 6.7],
    '8401920655475': ['ram', 2022, 2024, 6.7],
    '8401976623219': ['ram', 2003, 2004, 5.9],
    '8401976721523': ['ram', 2004, 2005, 5.9],
    '8401976787059': ['ram', 2006, 2007, 5.9],
    '8401976852595': ['ram', 2007, 2009, 6.7],
    '8401976950899': ['ram', 2010, 2012, 6.7],
    '8401985568883': ['eco', 2014, 2018, 3.0],
    '8401990221939': ['eco', 2019, 2019, 3.0],
    '8401990287475': ['eco', 2020, 2022, 3.0],
    '8401990353011': ['eco', 2023, 2023, 3.0]
  };
  const normalize = v => String(v || '').trim().toUpperCase();
  function validVin(vin) {
    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) return false;
    const values = '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ';
    const nums = '0123456789.12345678..12345.7.9..23456789';
    const weights = [8,7,6,5,4,3,2,10,0,9,8,7,6,5,4,3,2];
    const total = [...vin].reduce((sum, c, i) => sum + Number(nums[values.indexOf(c)]) * weights[i], 0);
    return vin[8] === (total % 11 === 10 ? 'X' : String(total % 11));
  }
  function matchVehicle(decoded, productId, options) {
    const base = bases[String(productId)];
    if (!base) return {ok:false, message:'Contact us to verify this package before ordering.'};
    const [family, firstYear, lastYear, litres] = base;
    let min = firstYear, max = lastYear;
    const selected = String(options || '').replace(/[–—]/g, '-');
    const text = selected.toLowerCase();
    const year = Number(decoded.ModelYear);
    const make = normalize(decoded.Make), model = normalize(decoded.Model);
    const series = normalize(decoded.Series);
    const label = [decoded.ModelYear, decoded.Make, decoded.Model, decoded.Series].filter(Boolean).join(' ');
    const codes = String(decoded.ErrorCode ?? '').split(',').map(x=>x.trim());
    if (!codes.length || codes.some(c => c !== '0') || !year || !make || !model) {
      return {ok:false, message:'The VIN lookup could not confirm a complete vehicle. Check the VIN or contact us.'};
    }
    if (String(productId) === '8401699504243') { if (text.includes('2015.5')) min=2015; else max=2015; }
    if (String(productId) === '8401729683571') { if (text.startsWith('2017-2018')) max=2018; else min=max=2019; }
    if (String(productId) === '8401749737587') { if (text.startsWith('2020-2023')) min=2020; else min=max=2019; }
    if (String(productId) === '8401920360563') { if (text.startsWith('2018')) min=max=2018; else max=2017; }
    if (String(productId) === '8401985568883') { if (text.startsWith('2018')) min=max=2018; else max=2017; }
    if (family==='ford') {
      if (text.includes('2011-2014 dawgs')) max=2014;
      if (text.includes('2015.5-2016 dawgs')) min=2015;
      if (text.startsWith('2017-2018:')) max=2018;
      if (text.startsWith('2019:')) min=max=2019;
      if (text.includes('2023-2024 only')) max=2024;
      if (text.startsWith('2023-2025') || text.startsWith('cab & chassis')) max=2025;
    }
    if (year < min || year > max) return {ok:false,message:label+' does not match the selected '+min+(max!==min?'–'+max:'')+' configuration.'};
    const modelText = model.replace(/[^A-Z0-9]/g,'');
    let modelOk = false;
    if (family==='ford') modelOk=make==='FORD' && (/^F(250|350)/.test(modelText) || (text.startsWith('cab & chassis') && /^F(450|550)/.test(modelText)));
    if (family==='gm') modelOk=(make==='CHEVROLET' && modelText.includes('SILVERADO') || make==='GMC' && modelText.includes('SIERRA')) && !/1500/.test(model+' '+series);
    if (family==='ram') modelOk=(make==='RAM'||make==='DODGE') && /2500|3500/.test(model+' '+series);
    if (family==='eco') modelOk=(make==='RAM'||make==='DODGE') && /1500/.test(model+' '+series);
    if (!modelOk) return {ok:false,message:label+' does not match the make and model supported by this package.'};
    if (!/DIESEL/.test(normalize(decoded.FuelTypePrimary)) || !Number(decoded.DisplacementL)) {
      return {ok:false,message:label+' was found, but its diesel engine could not be confirmed. Contact us before ordering.'};
    }
    if (Math.abs(Number(decoded.DisplacementL)-litres)>0.15) return {ok:false,message:label+' has a different engine from this package.'};
    if (text.includes('3500 leaf') && !/3500/.test(model+' '+series)) return {ok:false,message:'This 5-inch exhaust selection requires a Ram 3500 with leaf springs. Choose a compatible exhaust.'};
    let confirm='';
    if (String(productId)==='8401699504243' && year===2015) confirm='My truck has the '+(text.includes('2015.5')?'2015.5 3-bolt flange':'early-2015 V-band')+' selected above. VIN year alone cannot confirm the flange.';
    if (family==='ford' && year===2015 && text.includes('2015.5-2016 dawgs')) confirm='I have confirmed my truck is the 2015.5 configuration required by the selected EGR kit.';
    if (family==='ram' && text.includes('3500 leaf')) confirm='I have confirmed this Ram 3500 has leaf-spring rear suspension.';
    if (family==='ford' && firstYear===2023) confirm='I have confirmed my truck is a '+(text.startsWith('cab & chassis')?'cab-and-chassis':'pickup')+' and matches the selected exhaust configuration.';
    if (family==='ram' && (firstYear===2003 || firstYear===2004 || firstYear===2007)) confirm='I have confirmed the build-date and engine generation match this package; VIN model year alone cannot confirm a mid-year change.';
    return {ok:true,label,confirm,message:label+' — year, make, model and diesel engine match this selection.'};
  }
  if (typeof module!=='undefined' && module.exports) module.exports={validVin,matchVehicle,bases};
  if (!root.document) return;
  const doc=root.document, states=new WeakMap(), cache=new Map();
  const stop=e=>{e.preventDefault();e.stopImmediatePropagation();};
  const selectedId=form=>String(form.querySelector('[name="id"]')?.value||'');
  const property=(form,name,value)=>{const el=form.querySelector('[name="properties['+name+']"]');if(el)el.value=value;};
  const clearProperties=form=>['_VIN checked','_VIN variant','_VIN value','Vehicle verified','Fitment confirmation'].forEach(n=>property(form,n,''));
  function stateFor(field){if(!states.has(field))states.set(field,{key:'',ok:false,timer:null});return states.get(field);}
  function configFor(field){try{return JSON.parse(field.querySelector('[data-ddd-vin-config]').textContent);}catch{return null;}}
  function context(field){const form=field.closest('form'), vin=normalize(field.querySelector('[data-ddd-vin]').value), id=selectedId(form);return {form,vin,id,key:vin+'|'+id};}
  function result(field,message,ok=false){const el=field.querySelector('[data-ddd-vin-result]');el.textContent=message;el.dataset.state=ok?'valid':'invalid';}
  function reset(field){const c=context(field),s=stateFor(field);s.key=c.key;s.ok=false;clearProperties(c.form);field.querySelector('[data-ddd-fitment-wrap]').hidden=true;field.querySelector('[data-ddd-fitment]').checked=false;return c;}
  function decode(vin){
    if(cache.has(vin))return cache.get(vin);
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);
    const task=fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/'+encodeURIComponent(vin)+'?format=json',{signal:controller.signal,credentials:'omit',referrerPolicy:'no-referrer'})
      .then(r=>{if(!r.ok)throw new Error('lookup unavailable');return r.json();})
      .then(data=>{if(!data.Results?.[0])throw new Error('empty lookup');return data.Results[0];})
      .catch(error=>{cache.delete(vin);throw error;}).finally(()=>clearTimeout(timer));
    cache.set(vin,task);return task;
  }
  async function verify(field){
    const c=reset(field),s=stateFor(field),config=configFor(field),variant=config?.variants?.find(v=>String(v.id)===c.id);
    field.querySelector('[data-ddd-vin]').value=c.vin;
    if(!validVin(c.vin)){result(field,'Enter a valid 17-character VIN. Check the letters and numbers, including the check digit.');return;}
    if(!variant){result(field,'Select an available package configuration first.');return;}
    result(field,'Checking your vehicle…');
    const token={};s.request=token;
    try{
      const decoded=await decode(c.vin);
      if(s.request!==token||context(field).key!==c.key)return;
      const outcome=matchVehicle(decoded,config.productId,variant.options.join(' / '));
      result(field,outcome.message,outcome.ok);s.ok=outcome.ok;s.key=c.key;
      if(!outcome.ok)return;
      property(c.form,'Vehicle verified',outcome.label);
      property(c.form,'_VIN checked','NHTSA-2026-09-14');property(c.form,'_VIN variant',c.id);property(c.form,'_VIN value',c.vin);
      const wrap=field.querySelector('[data-ddd-fitment-wrap]');wrap.hidden=!outcome.confirm;
      field.querySelector('[data-ddd-fitment-text]').textContent=outcome.confirm;
      s.confirm=outcome.confirm;
    }catch{if(s.request===token&&context(field).key===c.key)result(field,'VIN lookup is temporarily unavailable. Try Verify VIN again, or contact us for help.');}
  }
  function invalidate(field){const s=stateFor(field);clearTimeout(s.timer);reset(field);result(field,'Verify your VIN for the selected package.');if(normalize(field.querySelector('[data-ddd-vin]').value).length===17)s.timer=setTimeout(()=>verify(field),550);}
  function focus(el){el.scrollIntoView({block:'center',behavior:'smooth'});el.focus({preventScroll:true});}
  function validForm(form,event){
    if(!form?.matches('form[action*="/cart/add"]'))return true;
    const field=form.querySelector('[data-ddd-vin-field]');
    if(field){const s=stateFor(field),c=context(field);if(!s.ok||s.key!==c.key){stop(event);verify(field);focus(field.querySelector('[data-ddd-vin]'));return false;}
      const check=field.querySelector('[data-ddd-fitment]');if(s.confirm&&!check.checked){stop(event);check.setCustomValidity('Confirm this hardware detail before adding your package.');check.reportValidity();focus(check);return false;}
      property(form,'Fitment confirmation',s.confirm||'');
    }
    const final=form.querySelector('[data-ddd-final-sale]');
    if(final&&!final.checked){stop(event);final.setCustomValidity('Please acknowledge that this purchase is final sale.');final.reportValidity();focus(final);return false;}
    return true;
  }
  function invalidLine(){return [...doc.querySelectorAll('[data-ddd-cart-check]')].find(el=>el.dataset.dddCartCheck!=='valid');}
  function checkout(event){const line=invalidLine();if(line){stop(event);line.hidden=false;focus(line);}}
  root.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;
    const verifyButton=target?.closest('[data-ddd-verify]');if(verifyButton){stop(event);verify(verifyButton.closest('[data-ddd-vin-field]'));return;}
    const quick=target?.closest('[data-action-atc]');
    if(quick){
      const quickForm=quick.closest('form[action*="/cart/add"]');
      if(quickForm){if(!validForm(quickForm,event))return;}
      else {stop(event);const link=quick.closest('.t4s-product')?.querySelector('a[href*="/products/"]');if(link)root.location.assign(link.href);else{const field=doc.querySelector('[data-ddd-vin],[data-ddd-final-sale]');if(field)focus(field);}return;}
    }
    const add=target?.closest('[data-atc-form],button[name="add"],button[type="submit"],input[type="submit"]');
    if(add?.form&&!validForm(add.form,event))return;
    if(target?.closest('[name="checkout"],[href*="/checkout"],[data-checkout],[data-cart-checkout]'))checkout(event);
  },true);
  root.addEventListener('submit',event=>{if(!validForm(event.target,event))return;if(event.target.action?.includes('/checkout')||event.submitter?.name==='checkout')checkout(event);},true);
  root.addEventListener('input',event=>{const el=event.target;if(el.matches?.('[data-ddd-vin]')){el.setCustomValidity('');invalidate(el.closest('[data-ddd-vin-field]'));}},true);
  root.addEventListener('change',event=>{const el=event.target;if(el.matches?.('[data-ddd-final-sale],[data-ddd-fitment]'))el.setCustomValidity('');},true);
  const refresh=()=>{
    doc.documentElement.classList.toggle('ddd-cart-needs-vin',!!invalidLine());
    doc.querySelectorAll('[data-ddd-vin-field]').forEach(field=>{const c=context(field),s=stateFor(field);if(c.key!==s.key)invalidate(field);});
  };
  const start=()=>{refresh();setInterval(refresh,500);};
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',start,{once:true});else start();
})(typeof window!=='undefined'?window:globalThis);
